import React from 'react';
import { connect } from 'react-redux';
//import './HashDemo.css';
import * as actions from '../actions.js';

import {
    Grid,
    PageHeader,
    Row,
    Col,
} from 'react-bootstrap';


//TODO: CONSIDER CHANGING THIS TO AN "OTHER" CATEGORY WITH SEVERAL MISC. CONCEPTS


function PaymentChannelDemo({ }) {
    return (
        <Grid>
            <PageHeader>
                Payment Channel Demonstration
            </PageHeader>
            <Row>
                <Col sm={12}>
                    Under Construction
                </Col>
            </Row>
        </Grid>
    );
}

function stateToProps({  }) {
    return {
    };
}
function dispatchToProps(dispatch) {
    return {
    };
}

export default connect(stateToProps, dispatchToProps)(PaymentChannelDemo);







// WEBPACK FOOTER //
// ./src/components/PaymentChannel.js